import React, { useState } from 'react';
import { TextField, Button, Box, Grid, FormLabel , InputLabel, FormControlLabel , RadioGroup, Radio } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import useStyles  from './useStyles'
import { ErrorMessage } from "@hookform/error-message";
import { singleInputValidator } from '../commons/utils';

const PasoTresForm = ({tramitaciongroup, setTramitaciongroup, antecedentesgenerales, setAntecedentesgenerales, setSolicitudConcreta, solicitudconcreta,  errors, setError}) => {
  
   


    const classes = useStyles();

    const handleChangeAntecedentesgenerales = evt => {
      setAntecedentesgenerales(evt.target.value)
    }

      const handleChangesolicitudconcreta = evt => {
        setSolicitudConcreta(evt.target.value)
    }

    const handleChangeTramitaciongroup = evt => {
      setTramitaciongroup(evt.target.value)
  }

    

    const [subTitulo, setSubTitulo] = useState('Tipo de tramitación') 

 

    return (


    <>
        {/* aca va el sub titulo del formulario */}
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
        </Box>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        <Grid>

        <FormControl className={classes.formControlComponent}>
            <RadioGroup row aria-label="tipotramitacion" name="tramitaciongroup" 
              onBlur={() => {
                //setTramitaciongroup(tramitaciongroup.trim())
                singleInputValidator(tramitaciongroup,"tramitaciongroup",setError, [])
              }}
              onChange={handleChangeTramitaciongroup}
            >
                <FormControlLabel value="consulta" control={<Radio />} label="Consulta" />
                <FormControlLabel value="opinion" control={<Radio />} label="Opinión o Sugerencia" />
                <FormControlLabel value="felicitaciones" control={<Radio />} label="Felicitaciones" />
                <FormControlLabel value="queja" control={<Radio />} label="Queja" />
               
            </RadioGroup>
            <ErrorMessage
                    style={{ color: 'red' }}
                    name="tramitaciongroup"
                    as="div"
                    errors={errors}
                  />
        </FormControl>


  

        <Box display="flex" justifyContent="start">
                <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>Datos de la consulta, sugerencia, opinión o felicitación</h3>
        </Box>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        
        
                <Box display="flex" justifyContent="start"  style={{ color: '#184ba3', fontSize: 16, fontWeight: 'bold', marginLeft: 40, marginRight: 40 , paddingTop: '15px' }} >

                <TextField fullWidth
                  id="antecedentesgenerales"
                  variant="outlined"
                  label="Descripción del Problema"
                  multiline
                  rows={4}
                  value={antecedentesgenerales}
                  onChange={handleChangeAntecedentesgenerales}
                  name="antecedentesgenerales"
                  onBlur={() => {
                    //setAntecedentesgenerales(antecedentesgenerales.trim())
                    singleInputValidator(antecedentesgenerales,"antecedentesgenerales",setError, [])
                  }}

                  />

                </Box>
                <ErrorMessage
                    style={{ color: 'red' }}
                    name="antecedentesgenerales"
                    as="div"
                    errors={errors}
                  />

                    
           
                <Box display="flex" justifyContent="start"  style={{ color: '#184ba3', fontSize: 16, fontWeight: 'bold', marginLeft: 40, marginRight: 40 , paddingTop: '15px' }} >
                <TextField fullWidth
                  id="solicitudconcreta"
                  variant="outlined"
                  label="Solicitud Concreta"
                  multiline
                  rows={4}
                  value={solicitudconcreta}
                  onChange={handleChangesolicitudconcreta}
                  name="solicitudconcreta"
                  onBlur={() => {
                    //setAntecedentesgenerales(solicitudconcreta.trim())
                    singleInputValidator(solicitudconcreta,"solicitudconcreta",setError, [])
                  }}

                  />
                           

                </Box>   
                  <ErrorMessage
                    style={{ color: 'red' }}
                    name="solicitudconcreta"
                    as="div"
                    errors={errors}
                  />
  
        </Grid>



      </>



  )
}

export default PasoTresForm